import { useEffect, useRef } from "react";

export function useResize(fn) {
  const cb = useRef(fn);

  useEffect(() => {
    const onResize = cb.current;

    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [cb]);
}
